/**
 * LockBadge — prominent locked-state indicator.
 *
 * Locked = "finished working on it" — must be immediately visible at a glance.
 * Uses an amber-tinted pill so it reads clearly in both themes without confusion
 * with error (red) or success (green) states.
 *
 * Usage:
 *   <LockBadge />               — icon only (for rows); tooltip/aria says "Locked"
 *   <LockBadge label />         — icon + "Locked" label (for meeting header chip)
 */

import { Icon } from "./icons";

interface LockBadgeProps {
  /** When true, renders the text label alongside the icon. Default: false. */
  label?: boolean;
  className?: string;
}

export function LockBadge({ label = false, className }: LockBadgeProps) {
  return (
    <span
      className={`lock-badge${label ? " lock-badge--labeled" : ""}${className ? ` ${className}` : ""}`}
      title="Locked"
      aria-label="Locked"
      role="img"
    >
      <Icon name="lock" size={label ? 13 : 12} aria-hidden />
      {label && <span className="lock-badge-text">Locked</span>}
    </span>
  );
}
